import React, { type FC, type ReactElement } from 'react';
import { TbCheck, TbX } from 'react-icons/tb';

const Boolean: FC<{
  value: boolean | undefined | null;
}> = function ({ value }): ReactElement {
  if (value === undefined || value === null) {
    return <span className='Boolean' />;
  }

  return <span className='Boolean'>
    {value ? (
      <TbCheck className='anticon' style={{ color: 'green' }} />
    ) : (
      <TbX className='anticon' style={{ color: 'red' }} />
    )}
  </span>;
};

export default Boolean;
